var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1.458c6.335 0 9.042 2.707 9.042 9.042v7c0 6.335-2.707 9.042-9.042 9.042h-7c-6.335 0-9.042-2.707-9.042-9.042v-7c0-6.335 2.707-9.042 9.042-9.042h7z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.167 19.25a1.75 1.75 0 0 1-1.75 1.75H7.583a1.75 1.75 0 0 1 0-3.5h12.834c.966 0 1.75.784 1.75 1.75zM19.104 13.417a1.75 1.75 0 0 1-1.75 1.75h-9.77a1.75 1.75 0 0 1 0-3.5h9.77c.967 0 1.75.783 1.75 1.75zM16.042 7.583a1.75 1.75 0 0 1-1.75 1.75H7.583a1.75 1.75 0 0 1 0-3.5h6.709c.966 0 1.75.784 1.75 1.75z",
    fill: "#FFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.6264cff3e56334eb09041f60413eb66d.svg";
export { ForwardRef as ReactComponent };